import { service } from '../../../../helpers/http' 

export const ActionGetAzureAdConfigurations = ({ dispatch }, payload) => { 
    return service({
        module: 'domainIntegrationAzureAd',
        action: 'getAzureAdConfigurations',
        payload: payload
    })
}

export const ActionPostAzureAdConfigurations = ({ dispatch }, payload) => {

    return service({
        module: 'domainIntegrationAzureAd',
        action: 'postAzureAdConfigurations',
        payload: payload
    })
    
}

export const ActionPutAzureAdConfigurations = ({ dispatch }, payload) => {

    return service({
        module: 'domainIntegrationAzureAd',
        action: 'putAzureAdConfigurations',
        payload: payload
    })
    
}

export const ActionDeleteAzureAdConfigurations = ({ dispatch }, payload) => {

    return service({
        module: 'domainIntegrationAzureAd',
        action: 'deleteAzureAdConfigurations',
        payload: payload
    })
    
}